var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-one-model-selector grid-container",attrs:{"qaid":"project-one-model-selector"}},[_c('project-one-bike-selection-card-list',{attrs:{"base-properties":_vm.baseProperties,"bikes":_vm.bikes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }